import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Text } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
import { Fragment, memo } from 'react';
import styles from './presenceList.module.scss';
import { PresenceListItem } from './presenceListItem';
export const PresenceList = memo(({ presenceByStatus, presence, profile, scroll }) => {
    let presenceList = (_jsxs("li", { children: [_jsx("h3", Object.assign({ className: styles.emptyListItemHead }, { children: "There's no one here yet" })), _jsx("p", Object.assign({ className: styles.emptyListItemText }, { children: "You can invite people by clicking on the \"+\" icon." }))] }));
    const isLoading = presence.allPresence.length === 0 &&
        presence.meta.asyncStatus === 'loading';
    const hasPresence = presence.allPresence.length > 0;
    const hasFailed = presence.allPresence.length === 0 &&
        presence.meta.asyncStatus === 'failed';
    const isOffline = presence.meta.offline === true;
    if (isLoading) {
        presenceList = (_jsx("li", { children: _jsx("h3", Object.assign({ className: styles.emptyListItemHead }, { children: "Loading" })) }));
    }
    else if (hasPresence) {
        presenceList = (_jsx(_Fragment, { children: presenceByStatus.map((group, groupIndex) => {
                if (!group.length)
                    return null;
                return (_jsxs(Fragment, { children: [_jsx("li", Object.assign({ className: styles.groupHead }, { children: _jsxs(Text.Paragraph, Object.assign({ variant: "3", color: colors.neutral['500'] }, { children: [group[0].presence.status, " (", group.length, ")"] })) })), _jsx("ul", Object.assign({ className: styles.list }, { children: group.map((userPresence, index) => (_jsx(PresenceListItem, { ownPresence: presence.presence, ownProfile: profile, userPresence: userPresence, index: index, groupIndex: groupIndex, scroll: scroll }, index))) }))] }, groupIndex));
            }) }));
    }
    else if (hasFailed) {
        presenceList = (_jsx("li", { children: _jsx("h3", Object.assign({ className: styles.emptyListItemHead }, { children: "Presence loading failed.." })) }));
    }
    else if (isOffline) {
        presenceList = (_jsx("li", { children: _jsx("h3", Object.assign({ className: styles.emptyListItemHead }, { children: "You are offline" })) }));
    }
    return (_jsx(Box, Object.assign({ padding: "0 200" }, { children: _jsx("ul", Object.assign({ className: styles.list }, { children: presenceList })) })));
});
// Adding a displayName manually since TS complains after wrapping the component in a React.memo
// @see https://github.com/yannickcr/eslint-plugin-react/issues/2133
PresenceList.displayName = 'PresenceList';
